import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import SpartaTabNavUtility from '@sparta.global.utilities/sparta-tab-nav-utility/dist/es6.js';
import pageScrollUtility from '@sparta.sales.utilities/page-scroll-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import focusTrapUtility from '@sparta.global.utilities/focus-trap-utility/dist/es6.js';
import spartaLazyLoadUtility from '@sparta.global.utilities/sparta-lazy-load-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { checkbox } from '@sparta.global.helpers/checkbox-helper/dist/es6.js';
import { radioButton } from '@sparta.global.helpers/radio-button-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { layerContent, debug } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { tabNavigation } from '@sparta.global.helpers/tab-navigation-helper/dist/es6.js';
import { cardHelper } from '@sparta.global.helpers/card-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0))
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"tabNavigation")||(depth0 && lookupProperty(depth0,"tabNavigation"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"tabNav") : stack1),{"name":"tabNavigation","hash":{},"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":7,"column":39}}}))
    + "\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "tab-content";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div\r\n        class=\"sticky spa-sticky\"\r\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyLevel") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":18,"column":83}}})) != null ? stack1 : "")
    + "\r\n        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":8},"end":{"line":19,"column":96}}})) != null ? stack1 : "")
    + "\r\n      >\r\n        <div class=\"text-disclosure\">\r\n          <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"sticky") : stack1)) != null ? lookupProperty(stack1,"text-disclosure") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n      </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-level=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyLevel") : stack1), depth0))
    + "\"";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-full-width=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1), depth0))
    + "\"";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"last")),{"name":"unless","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":32,"column":2},"end":{"line":38,"column":13}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":33,"column":13},"end":{"line":33,"column":21}}}) : helper)))
    + "Panel\" role=\"tabpanel\">\r\n      "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"cardPartial") : stack1)) != null ? lookupProperty(stack1,"layerData") : stack1)) != null ? lookupProperty(stack1,"layer") : stack1),{"name":"layerContent","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":17}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"filterOnly") : stack1),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + "\r\n<div id=\"filterContainer\" class=\"row filter "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"filterOnly") : stack1),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":44},"end":{"line":10,"column":95}}})) != null ? stack1 : "")
    + "\" role=\"tabpanel\">\r\n  <div class=\"column small-12 large-centered container\">\r\n    <div>\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"filterCardsButton") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":13,"column":40}}}))
    + "\r\n    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"sticky") : stack1)) != null ? lookupProperty(stack1,"text-disclosure") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":4},"end":{"line":25,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  "
    + container.escapeExpression((lookupProperty(helpers,"cardHelper")||(depth0 && lookupProperty(depth0,"cardHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"cardPartial") : stack1),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"cardPartial") : stack1)) != null ? lookupProperty(stack1,"layerData") : stack1),{"name":"cardHelper","hash":{},"data":data,"loc":{"start":{"line":28,"column":2},"end":{"line":28,"column":71}}}))
    + "\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"children") : depth0),{"name":"each","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":0},"end":{"line":39,"column":9}}})) != null ? stack1 : "")
    + "\r\n<div id=\"noResultsCategory\" class=\"row hide\">\r\n  <div class=\"column text-center\">\r\n    <h2 class=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"noResultsCategory") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n    <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"noResultsCategory") : stack1)) != null ? lookupProperty(stack1,"subheading") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n  </div>\r\n</div>\r\n\r\n<div id=\"noResultsViewAll\" class=\"row hide\">\r\n  <div class=\"column text-center\">\r\n    <h2 class=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"noResultsViewAll") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n    <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"noResultsViewAll") : stack1)) != null ? lookupProperty(stack1,"subheading") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div id=\"filterOptions\" class=\"filter-options\" data-font=\"cnx-regular\">\r\n  <div class=\"row small-12 clear-all\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"reset") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":4,"column":33}}})) != null ? stack1 : "")
    + "\r\n  </div>\r\n  <div class=\"row small-12 fees\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"checkbox")||(depth0 && lookupProperty(depth0,"checkbox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ratesAndFeesCheckboxGroup") : depth0),{"name":"checkbox","hash":{},"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":7,"column":49}}})) != null ? stack1 : "")
    + "\r\n    <hr class=\"line1\">\r\n  </div>\r\n  <div class=\"row small-12 features\">\r\n    <div class=\"spa-input spa-input--sparta2\">\r\n      <div class=\"spa-fieldset-label\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"featuresCheckboxGroup") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n    </div>\r\n    <div class=\"input-single\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"checkbox")||(depth0 && lookupProperty(depth0,"checkbox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"featuresCheckboxGroup") : depth0),{"name":"checkbox","hash":{},"data":data,"loc":{"start":{"line":20,"column":6},"end":{"line":20,"column":47}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <hr>\r\n  </div>\r\n  <div class=\"row small-12 card-type\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"radioButton")||(depth0 && lookupProperty(depth0,"radioButton"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cardTypeRadioGroup") : depth0),{"name":"radioButton","hash":{},"data":data,"loc":{"start":{"line":25,"column":4},"end":{"line":25,"column":45}}})) != null ? stack1 : "")
    + "\r\n  </div>\r\n  <div class=\"cta-buttons\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"cancel") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":28,"column":4},"end":{"line":28,"column":34}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"search") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":28,"column":35},"end":{"line":28,"column":65}}})) != null ? stack1 : "")
    + "\r\n  </div>\r\n</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/product-filter-cc-module",
  "version": "5.0.0",
  "id": "ProductFilterCcModule",
  "containerID": "creditCardsProductFilterCcModule",
  "moduleName": "credit-cards-product-filter-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-filter-cc-module",
  "data": {
    "init": "ProductFilterCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "stickyLevel",
    "type": "Number",
    "default": 2,
    "description": "sticky level"
  }, {
    "name": "stickyFullWidth",
    "type": "boolean",
    "default": true,
    "description": "sticky full width"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        checkbox,
        radioButton,
        button,
        layerContent,
        debug,
        tabNavigation,
        cardHelper
      },
      "partials": {
        "product-filter-cc-module-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "product-filter-cc-module-partial": renderTemplate
  },
  "helpers": {
    checkbox,
    radioButton,
    button,
    layerContent,
    debug,
    tabNavigation,
    cardHelper
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/card-helper": "^1.0.0",
    "@sparta.global.helpers/checkbox-helper": "^1.0.0",
    "@sparta.global.helpers/radio-button-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/tab-navigation-helper": "^1.0.0",
    "@sparta.global.utilities/focus-trap-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-lazy-load-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.global.utilities/sparta-tab-nav-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.sales.utilities/page-scroll-utility": "^1.0.0"
  },
  "stores": []
};

/* global Handlebars */

/**
 * product-filter-cc-module
 * module_js_id: ProductFilterCcModuleJS
 *
 * Copyright (c) 2017-12-5 removed
 *
 */

/**
 * ProductFilterCcModuleJS class
 */
class ProductFilterCcModuleJS extends Module {
  /**
   * constructor
   *
   * @param {*} options options object
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.hash = window.location.hash.substr(1);
    this.category = this.hash || 'featured';
    this.filtersEl = target.querySelector('#filterContainer');
    this.filterCloseButton = target.querySelector('.icon-close');
    this.filterCard = target.querySelector('.spa-card');
    this.filterCardClose = target.querySelector('.spa-card__dismissible');
    this.filterCardCancel = target.querySelector('#cancelFilter');
    this.filterOptions = target.querySelector('.filter-options');
    this.filterCardLayer = target.querySelector('#filter-card-small-only-layer');
    this.filterInputs = [...this.filterOptions.querySelectorAll('input')];
    this.filterMenuCta = target.querySelector('.filter-trigger');
    this.filterMenuCtaText = this.filterMenuCta.innerText;
    this.filterMenuCount = this.filterMenuCta.querySelector('.count');
    this.filterMenuSubmit = target.querySelector('#searchCards');
    this.filterMenuReset = target.querySelector('#resetSearch');
    this.cardsAll = target.querySelector('#allCards .cards-list-placeholder');
    this.cardList = JSON.parse(target.querySelector('.card-list').dataset.jcr) || null;
    this.noResultsCategory = document.getElementById('noResultsCategory');
    this.noResultsViewAll = document.getElementById('noResultsViewAll');
    this.isSmallScreen = spartaMediaQueryUtility.getCurrentViewport().currentViewport.includes('small');
  }

  /**
   * Initialize the module
   * @returns {void}
   */
  init() {
    SpartaTabNavUtility.init();
    this.bindEvents();
    this.bindEventListeners();
  }

  /**
   * Bind subscription events
   * @returns {void}
   */
  bindEvents() {
    spartaEventsUtility.sub(creditCardUtility.EVENTS.cardListCount, res => {
      const {
        data
      } = res;
      const {
        count
      } = data;
      this.noResultsCategory.classList.add('hide');
      this.noResultsViewAll.classList.add('hide');
      if (!count) {
        if (this.category === 'filter') {
          this.noResultsViewAll.classList.remove('hide');
        } else {
          this.noResultsCategory.classList.remove('hide');
        }
      }
    });
    spartaEventsUtility.sub(creditCardUtility.EVENTS.cardListReady, res => {
      const {
        data
      } = res;
      if (data.id === 'allCards') {
        this.setActiveState();
      }
    });
    spartaEventsUtility.sub(creditCardUtility.EVENTS.errorShowHome, () => {
      if (this.isSmallScreen) {
        Object.assign(this.filterCard.style, {
          top: '-180px'
        });
      }
    }, true);
  }

  /**
   * Bind event listeners and functions
   * @returns {void}
   */
  bindEventListeners() {
    const {
      target
    } = this.settings;
    window.addEventListener('hashchange', this.handleHashChange.bind(this));
    this.filterMenuCta.addEventListener('click', this.handleFilterMenuCta.bind(this, true));
    this.filterCardClose.addEventListener('click', this.handleFilterMenuCta.bind(this, true));
    this.filterCardCancel.addEventListener('click', this.handleFilterMenuCta.bind(this, true));
    this.filterMenuReset.addEventListener('click', this.handleFilterMenuReset.bind(this));
    this.filterMenuSubmit.addEventListener('click', this.handleFilterMenuSubmit.bind(this, true));
    creditCardUtility.delegateEvent('click', '.filter-options label a', e => {
      e.preventDefault();
      e.target.parentNode.click();
    }, false, target);
    this.filterInputs.forEach(input => {
      input.parentElement.addEventListener('keydown', this.enterKeyCheckboxSelect.bind(this));
    });
  }

  /**
   * Handler for reseting the filter menu
   * @returns {void}
   */
  handleFilterMenuReset() {
    this.filterInputs.forEach(input => {
      Object.assign(input, {
        checked: false
      });
    });
    let filter = {};
    filter = {
      category: [this.category]
    };
    this.publishFilter(this.moduleId, filter);
    this.filterMenuCta.innerText = this.filterMenuCtaText;
    if (this.filterMenuCta.classList.contains('filtered')) {
      this.filterMenuCta.classList.remove('filtered');
      this.filterMenuCta.classList.add('unfiltered');
    }
    this.filterMenuCta.focus();
    this.handleFilterMenuCta(true);
  }

  /**
   * Handler for filter menu submit
   * @param {boolean} doFocus - boolean to set focus on filter cta button -
   * prevents focus on hash change
   * @returns {void}
   */
  handleFilterMenuSubmit(doFocus) {
    const filter = {};
    const ratesFees = [];
    this.filterInputs.forEach(input => {
      if (input.name === 'cardType' && input.checked) {
        filter.type = input.value;
      }
      if (input.name === 'preferredRewards' && input.checked) {
        filter.features = [input.value];
      }
      if (input.name !== 'preferredRewards' && input.type === 'checkbox' && input.checked) {
        ratesFees.push(input.value);
      }
    });
    if (ratesFees.length) {
      filter.ratesFees = ratesFees;
    }
    filter.category = [this.category];
    this.publishFilter(this.moduleId, filter);
    this.manipulateFilterCardCta(filter);
    if (doFocus) {
      this.filterMenuCta.focus();
      this.handleFilterMenuCta(true);
    } else {
      this.handleFilterMenuCta(false);
    }
  }

  /**
   * Handler for CTA in filter menu
   * Toggles the active and visible classes
   * @param {boolean} doScroll - true/false to scroll filter menu into view
   * @returns {void}
   */
  handleFilterMenuCta(doScroll) {
    this.filterMenuCta.classList.toggle('active');
    this.filterCard.classList.toggle('hidden');
    this.manipulateCardLayer();

    // scroll on boolean
    if (doScroll) {
      if (!this.isSmallScreen) {
        pageScrollUtility.scrollToID(this.filterMenuCta.id, 65);
      } else {
        pageScrollUtility.scrollToID(this.filterCard.id, 50);
      }
    }
  }

  /**
   * Hash change handler function
   * @returns {void}
   */
  handleHashChange() {
    this.hash = window.location.hash.substr(1);
    this.category = this.hash || 'featured';
    this.setActiveState();
    if (!this.isSmallScreen) {
      pageScrollUtility.scrollToID(this.filterMenuCta.id, 65);
    } else {
      pageScrollUtility.scrollToID(this.filterCard.id, 50);
    }
  }

  /**
   * Sets active page state when card list loads or hash changes
   * @returns {void}
   */
  setActiveState() {
    this.cardsAll.classList.remove('active');

    // Set primary tabs
    this.setActiveTabs();
    const filter = {};
    const moduleId = 'allCards';
    this.moduleId = moduleId;
    this.cardsAll.classList.add('active');
    filter.category = [this.category];
    this.publishFilter(moduleId, filter);
    this.handleFilterMenuSubmit(false);
    this.handleFilterMenuCta(false);
  }

  /**
   * Sets active class on tab navigation when state changes
   * @returns {void}
   */
  setActiveTabs() {
    this.filtersEl.classList.add('visible');
    if (!this.hash) {
      const tabId = `tab-${this.category}`;
      const tabEl = document.getElementById(tabId);
      if (!tabEl) return;
      SpartaTabNavUtility.openPanel(tabId);
      tabEl.classList.add('spa-tab__activate-on-load');
    }
  }

  /**
   * publishFilter
   *
   * @description
   * "filter": {
   *   "type": "masterCard", // "visa"
   *   "features": ["preferredRewards"],
   *   "ratesFees": ["noAnnualFee", "noForeignTransactionFee",
   *      "zeroAprBalance", "zeroAprPurchase"],
   *   "category": ["cash", "lowInterest", "buildCredit",
   *      "points", "students", "travel"]
   * }
   * @param {String} moduleId - ID of the module
   * @param {Object} filter - filter to apply
   * @returns {void}
   */
  publishFilter(moduleId, filter) {
    spartaEventsUtility.pub(creditCardUtility.EVENTS.cardListFilter, {
      id: moduleId,
      filter
    });
  }

  /**
   * Sets check box checked/unchecked on enter key
   * @param {event} event - enter keyup
   * @returns {void}
   */
  enterKeyCheckboxSelect(event) {
    if (event.keyCode === 13) {
      const {
        target
      } = event;
      // eslint-disable-next-line no-unused-expressions
      target.checked === false ? target.checked = true : target.checked = false;
    }
  }

  /**
   * Helper function accepting 2 elements.
   * The first is hidden from screenreaders while the second is shown.
   * @param {HTMLElement} elToHide element to set aria-hidden = "true"
   * @param {HTMLElement} elToShow element to set aria-hidden = "false"
   * @returns {void}
   */
  adaHideShow(elToHide, elToShow) {
    elToHide.setAttribute('aria-hidden', true);
    elToShow.setAttribute('aria-hidden', false);
    spartaLazyLoadUtility.init();
  }

  /**
   * Manipulates the grey background layer behind the small view port filter card
   * Only fires on small viewport
   * @returns {void}
   */
  manipulateCardLayer() {
    const container = this.filterCard;
    const layerBeginText = 'Filter card begin';
    const layerEndText = 'Filter card end';
    if (!this.filterCard.classList.contains('hidden') && this.isSmallScreen) {
      const documentHeight = document.body.scrollHeight;
      const documentWidth = document.body.scrollWidth;
      const heightFromParentTop = document.querySelector('#ProductFilterCcModule').offsetTop;
      const headerHeight = document.querySelector('#head-row').clientHeight;
      const total = heightFromParentTop + headerHeight;
      const layerStyles = {
        position: 'absolute',
        top: `-${total}px`,
        height: `${documentHeight}px`,
        width: `${documentWidth}px`,
        zIndex: '1001',
        // has to cover sticky header (z of 1000)
        backgroundColor: '#464646',
        // dark grey
        opacity: '0.7'
      };
      this.filterCardLayer.classList.remove('hide');
      Object.assign(this.filterCardLayer.style, layerStyles);
      Object.assign(this.filtersEl.style, {
        zIndex: '1002'
      });
      focusTrapUtility({
        container,
        layerBeginText,
        layerEndText
      }).attachTrap();
    } else {
      focusTrapUtility({
        container,
        layerBeginText,
        layerEndText
      }).removeTrap();
      Object.assign(this.filtersEl.style, {
        zIndex: '10'
      });
      this.filterCardLayer.classList.add('hide');
    }
  }

  /**
   * Allows for the close icon reset event to fire on enter key as well as click
   * @param {event} event - key event
   * @returns {void}
   */
  closeIconEnterReset(event) {
    if (event.keyCode === 13) {
      this.handleFilterMenuReset();
    }
  }

  /**
   * Manipulates the "Filter Card" button once inputs have been selected
   * and user clicks to view cards
   * @param {Object} filter - filter that will be applied
   * @returns {void}
   */
  manipulateFilterCardCta(filter) {
    const selectionArray = [];

    // filters selected input values into array
    Object.keys(filter).forEach(key => {
      if (key !== 'category') {
        const item = filter[key];
        if (Array.isArray(item)) {
          item.forEach(value => {
            selectionArray.push(value);
          });
        } else {
          selectionArray.push(item);
        }
      }
    });
    const firstPosition = selectionArray[0];
    const totalNumber = selectionArray.length - 1;

    // uses first position in array to target the input's text by ID
    if (firstPosition) {
      let firstText = document.querySelector(`#${firstPosition}`).parentElement.lastChild.innerText;

      // manipulates based on if Visa or Mastercard to account for trademarked symbol
      if (firstText.includes('®')) {
        firstText = firstText.slice(0, firstText.lastIndexOf('®') + 1);
      }
      let fullText = '';

      // decides if there will be a + number appendeed to button content
      if (totalNumber >= 1) {
        fullText = `${firstText} +${totalNumber}`;
      } else {
        fullText = `${firstText}`;
      }
      const isSpanish = this.Store.getData('lang') === 'es-us';

      // decides for English vs Spanish filter text
      if (!isSpanish) {
        this.filterMenuCta.innerText = `Filter: ${fullText}`;
      } else {
        this.filterMenuCta.innerText = `Filtrar: ${fullText}`;
      }
      if (this.filterMenuCta.classList.contains('unfiltered')) {
        this.filterMenuCta.classList.remove('unfiltered');
        this.filterMenuCta.classList.add('filtered');
      }

      // creates and appends the close icon
      const icon = document.createElement('div');
      icon.classList.add('spa-icon');
      icon.classList.add('icon-close');
      icon.classList.add('filter-button-close');
      icon.tabIndex = 0;
      this.filterMenuCta.appendChild(icon);
      document.querySelector('.filter-button-close').addEventListener('click', this.handleFilterMenuReset.bind(this));
      document.querySelector('.filter-button-close').addEventListener('keydown', this.closeIconEnterReset.bind(this));
    }
  }
}
registerModuleClass({
  moduleClass: ProductFilterCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ProductFilterCcModuleJS as default, moduleConfig };
